
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { WebTableDataset } from '../../model/dataset/web-table.dataset';
import { Metamodel } from 'app/model/base/model';
import { WebTableLinkedService } from 'app/model/linkedservice/web-table.linkedservice';

export const webTableMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(WebTableDataset).name,
    supportLinkedServiceTypes: [Metamodel.modelFor(WebTableLinkedService).name],
    displayName: stringResources.WebTable_DisplayText,
    datasetKind: 'table',
    isSource: true,
    isSink: false,
    tableNameDisplay: stringResources.WebTable_Dataset_TableIndex,
    tableNamePlural: stringResources.Indexes,
    disableTableName: true,
    notSupportCopySourceQuery: true,
    icon: {
        className: 'svg-i-100x100-web_table'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
